export default __webpack_public_path__ + "static/media/1093.274de9ef.png";